import React from 'react';
import ReactDiffViewer from 'react-diff-viewer-continued';
import { match } from 'ts-pattern';

import { Block } from '@eluve/llm-outputs';

import { normalizeForDiff } from './normalizeForDiff';

export const DiffViewer: React.FC<{
  oldBlock: Block;
  newBlock: Block;
  showDiffOnly?: boolean;
}> = ({ oldBlock, newBlock, showDiffOnly = false }) => {
  return match({ oldBlock, newBlock })
    .with(
      { oldBlock: { type: 'text' }, newBlock: { type: 'text' } },
      ({ newBlock, oldBlock }) => {
        return (
          <ReactDiffViewer
            oldValue={normalizeForDiff(oldBlock.text ?? '')}
            newValue={normalizeForDiff(newBlock.text ?? '')}
            splitView={true}
            showDiffOnly={showDiffOnly}
          />
        );
      },
    )
    .with(
      { oldBlock: { type: 'range' }, newBlock: { type: 'range' } },
      ({ newBlock, oldBlock }) => {
        return (
          <ReactDiffViewer
            oldValue={`${oldBlock.value}`}
            newValue={`${newBlock.value}`}
            splitView={true}
            showDiffOnly={showDiffOnly}
          />
        );
      },
    )
    .with(
      {
        oldBlock: { type: 'checkbox' },
        newBlock: { type: 'checkbox' },
      },
      ({ newBlock, oldBlock }) => {
        return (
          <ReactDiffViewer
            oldValue={JSON.stringify(oldBlock.options, undefined, 2)}
            newValue={JSON.stringify(newBlock.options, undefined, 2)}
            splitView={true}
            showDiffOnly={showDiffOnly}
          />
        );
      },
    )
    .with(
      {
        oldBlock: { type: 'group' },
        newBlock: { type: 'group' },
      },
      ({ newBlock, oldBlock }) => {
        return (
          <DiffViewer
            oldBlock={oldBlock}
            newBlock={newBlock}
            showDiffOnly={showDiffOnly}
          />
        );
      },
    )
    .otherwise(() => (
      <div>
        Old block output type {oldBlock.type} and/or new block type
        {newBlock.type} are not supported
      </div>
    ));
};
